// extracted by mini-css-extract-plugin
module.exports = {"box":"_143rb7cB5SAutk2CwECQrd"};